
import Vue from "vue";
import Component from "vue-class-component";
import DateInput from "@/components/wmc/DateInput.vue";
import { parse } from "date-fns";

@Component({
  name: "ListaPedidosFilter",
  components: {
    DateInput,
  },
  props: {
    data_inicio: {
      type: Date,
      default: "",
    },
    origem: {
      type: String,
      default: "",
    },
  },
})
export default class ListaPedidosFilter extends Vue {
  get getBaseDtini() {
    if (this.$props.data_inicio) {
      return this.$props.data_inicio;
    }
    const dt = new Date(Date.now());
    dt.setUTCMonth(dt.getUTCMonth() - 1);
    return dt;
  }

  tipoPedidoMap = {
    0: "Todos",
    V: "Venda",
    B: "Bonificação",
    T: "Troca",
    A: "Amostra",
    C: "Comodato",
    O: "Consignação",
    N: "Conta e Ordem",
    M: "Compra",
    R: "Carga",
    X: "Devolução Venda",
    D: "Devoluções",
    E: "Entrada",
    S: "Retorno de vasilhame",
    I: "Demonstração",
    J: "Retorno",
    L: "Remessa de Bem",
    F: "Outras Entradas",
    Q: "Outras Saídas",
    P: "Brinde",
    U: "Devolução Comodato",
    G: "Nota Fiscal",
    Z: "Entrada de Vasilhame",
    K: "Descarte Entrada",
    W: "Descarte Saída",
    Y: "Locação",
    "4": "Venda Balcão",
    "5": "Remessa para Consignação",
    "6": "Venda de Consignação",
    "7": "Retorno de Consignação",
    "8": "Comodato Temporário",
    "9": "Dev Comodato Temporário",
    "1": "Transferência",
    "3": "Remessa para Reparo",
    "2": "Televendas",
  };

  private situacoesList = [
    {
      id: "",
      value: "Todos",
    },
    {
      id: "PENDENTE",
      value: "Pendente",
    },
    {
      id: "EM ROMANEIO",
      value: "Em Romaneio",
    },
    {
      id: "FATURADO",
      value: "Faturado",
    },
    {
      id: "CANCELADO",
      value: "Cancelado",
    },
  ];

  private origensList = [
    {
      id: "TODOS",
      value: "Todos",
    },
    {
      value: "Portal Cliente",
      id: "PORTAL",
    },
    {
      value: "Sistema Gestão",
      id: "GESTAO",
    },
  ];

  private situacaoFilter = "";
  private origemFilter = this.$props.origem;
  private search = "";
  private dtIni = this.getBaseDtini;
  private dtFim = new Date(Date.now());
  tipoPedido = "";

  private textSearchTimer;

  private get getDtIni() {
    return this.dtIni.toISOString();
  }
  private get getDtFim() {
    return this.dtFim.toISOString();
  }

  mounted() {
    const { periodoini, periodofim, situacao, search, origem, tipoPedido } =
      this.$router.currentRoute.query;

    this.situacaoFilter = situacao as string;
    if (origem) this.origemFilter = origem as string;
    this.search = search as string;
    this.tipoPedido = tipoPedido as string;

    if (periodoini) this.dtIni = new Date(periodoini as string);
    if (periodofim) this.dtFim = new Date(periodofim as string);
  }

  get getColunasSizeFiltro() {
    if (this.$vuetify.breakpoint.smAndDown) {
      return {
        cols: 12,
      };
    }

    return {};
  }

  onDtIniChange(newDt: string) {
    const dt = parse(newDt, "yyyy-MM-dd", new Date());
    this.$router.push({
      query: {
        ...this.$router.currentRoute.query,
        page: "1",
        periodoini: newDt ? dt.toISOString() : undefined,
      },
    });
  }

  onDtFimChange(newDt: string) {
    const dt = parse(newDt, "yyyy-MM-dd", new Date());
    this.$router.push({
      query: {
        ...this.$router.currentRoute.query,
        page: "1",
        periodofim: newDt ? dt.toISOString() : undefined,
      },
    });
  }

  onSituacaoChange() {
    this.$router.push({
      query: {
        ...this.$router.currentRoute.query,
        page: "1",
        situacao: this.situacaoFilter || undefined,
      },
    });
  }

  onOrigemChange() {
    // change router withot push
    this.$router.replace({
      query: {
        ...this.$router.currentRoute.query,
        page: "1",
        origem: this.origemFilter || undefined,
      },
    });
  }

  onSearchTextChanged(value: string, oldValue: string) {
    clearTimeout(this.textSearchTimer);
    this.textSearchTimer = setTimeout(() => {
      this.$router.push({
        query: {
          ...this.$router.currentRoute.query,
          page: "1",
          search: this.search || undefined,
        },
      });
    }, 600);
  }

  onTipoPedidoChange() {
    this.$router.push({
      query: {
        ...this.$router.currentRoute.query,
        page: "1",
        tipoPedido: this.tipoPedido || undefined,
      },
    });
  }
}
